export { default } from './DynamicHighchart'
